import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./containers/App"
import configureStore from "./configureStore";
import { DataProvider } from "./context/DataContext";
import { APIProvider } from "./context/ApiContext";
import { ToasterProvider } from "./context/ToasterContext";
import ToastNotification from "./components/ToastNotification";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallbackComponent from "./components/ErrorBoundary/ErrorBoundaryComponent";
import { BrowserRouter } from 'react-router-dom';
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
import { analyticsInitialize } from './utils/analytics';

// Load the favicon and the .htaccess file
// import "!file-loader?name=[name].[ext]!./images/chase-favicon.ico";

const initialState = {};
const store = configureStore(initialState);
const root = ReactDOM.createRoot(
  document.getElementById('root')
);

analyticsInitialize();

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_ID,
//   integrations: [new BrowserTracing()],
//   tracesSampleRate: 1.0,
// });

root.render(
  <Provider store={store}>
      <BrowserRouter>
        <DataProvider>
          <APIProvider>
            <ToasterProvider>
              <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
                <ToastNotification />
                <App />
              </ErrorBoundary>
            </ToasterProvider>
          </APIProvider>
        </DataProvider>
      </BrowserRouter>
  </Provider>
);
